import React, { Component, Fragment } from 'react';
import request from '../../request';
import * as print from 'print';
import Snackbar from './../common/Snackbar';
import { ItemDetails } from './../../components/common';
import styles from './../Scan/styles.scss';
import scanImage from '../../images/sku-scan.png';

export default class PrintAsnPbarcode extends Component {
    state = {
      items:[],
      id_partner:'',
      showModal: false
    };

    componentDidMount = () => {
      if (this.scanInput) {
        this.scanInput.focus();
        window.addEventListener('click', this.pageClick, false);
      }
      this.setState({
        id_partner: this.props.match.params.idPartner,
        id_asn: this.props.match.params.idAsn,
        is_supervisor: window.location.pathname.includes('/asn-discrepancy'),
        is_xdock: window.location.href.indexOf('xdock') > 0
      });
    };

    pageClick = () => {
      if (this.scanInput) {
        const x = window.scrollX,
            y = window.scrollY;
        this.scanInput.focus();
        window.scrollTo(x, y);
      }
    };

    componentWillUnmount = () => {
      window.removeEventListener('click', this.pageClick, false);
    };

    onChange = event => this.setState({err:false,success:false,msg:'',showModal:false});

    onKeyPress = event => {
      if (event.target.value && event.key === 'Enter') {
        this.getSourceType(event.target.value);
        event.target.value = '';
      }
    };
  
    getSourceType = (pbarcode) => {
      const { id_asn } = this.state;
      request
        .get(`/_svc/inbound-po-api/asn/${id_asn}/source-data`)
        .then(response => {
          if (response.source_type === "POSHIP") {
            this.setState({ asn_nr: response.asn_nr, source_type: response.source_type, source_nr: response.source_nr, pbarcode})
            this.checkPbarcode(response.source_nr, pbarcode)
          }
          else
            this.getPbarcode(pbarcode)
        })
        .catch(error => 
          this.setState({ err: true, msg: error.error || 'Something went wrong, please retry' })
        )
    }

  checkPbarcode = (source_nr, pbarcode) => {
    const { id_partner, is_supervisor } = this.state;
    request
      .post(`/_svc/retail-order-api/po-line/check-barcode`, {id_partner, pbarcode,source_nr})
      .then(response => this.getPbarcode(pbarcode))
      .catch(error => {
        if (error.code === 400 && is_supervisor) {
          this.setState({ success: true, msg: error.error })
          return;
        }
        if (error.code === 400 && !is_supervisor) {
          this.printLabel([{ pbarcode: 'NOT FOUND', barcode: "NOT FOUND", IDPARTNER:'' }])
          this.setState({ success: true, msg: error.error })
          return;
        }
        this.setState({ err: true, msg: error.error || 'Something Went Wrong' })
      })
  }

  getPbarcode = (barcode) => {
    const { id_partner } = this.state;
    request
      .post(`/_svc/wms-api/item/lot-pbarcode`,{lots:[{id_partner,pbarcode:barcode}]})
      .then(response =>
        this.setState({success:true,msg:`${barcode} Scanned Successfully`},()=>{
          // this.printLabel(response.lots);
          this.getItemDetails(response.lots,id_partner)
        })
      )
      .catch(error=>{
        if(error.code === 400) {
          this.setState({ success: true, msg: error.error || `${barcode} is INVALID BARCODE`})
          return;
        }
        this.setState({err:true, msg:error ? error.error : 'Something went wrong, please retry'})
      });
    }

    getItemDetails = (lots,id_partner) => {
      const pbarcode = lots[0]['pbarcode'];
      request
        .post(`/_svc/inbound-po-api/pbarcode-detail`,{partner_barcode:[pbarcode],id_partner})
        .then(response => {
          const lotsWithItemDetails = lots.map(lot => ({ ...lot, ...response, label: response.title_en }))
          this.printLabel(lotsWithItemDetails);
          this.setState({item:response,showModal:true})
        }
        )
        .catch(error => this.setState({err:true, msg:error ? error.error : 'Something went wrong, please retry',}))
    }

    getLabel = (is_xdock, item) => {
      if(is_xdock)
        item.barcode = item.pbarcode;
      
      return print.generateMpLabel(item);
    }
    
    printLabel = (items) => {
      const { is_xdock } = this.state;
      const labels = items.map(item => this.getLabel(is_xdock, item))
      print.print(labels);
      this.setState({loading:false})
    };

    render() {
      const { err, success, msg, item, showModal } = this.state;
      return (
        <Fragment>
          <div className={styles.scanContainer}>
          {
            showModal ?
              ItemDetails(item, undefined) :
              <React.Fragment>
                <img
                  className={styles.scanImage}
                  src={scanImage}
                  alt="SKUScan"/>
                <p className={styles.scanTitle}>
                  Scan Product Barcode to View Details
                </p>
                <p className={styles.scanSubTitle}>
                  Please make sure you scan the barcode properly
                </p> 
              </React.Fragment>
          }
          <input
            className={styles.sku}
            type="text"
            onKeyPress={(evt)=>this.onKeyPress(evt)}
            onChange={(evt)=>this.onChange(evt)}
            ref={input => {
                this.scanInput = input;
            }}
          />
          {
            (err || success) ? 
              <Snackbar msg={msg}/>:''
          }
          </div>
        </Fragment>
      );
    }
}


// WEBPACK FOOTER //
// ./src/components/PrintAsnPbarcode/index.js